import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const faqs = [
  {
    q: "¿Dónde está ubicado el restaurante?",
    a: "Nos encontramos en Ctra. Ansoáin, 6, 31013 Ansoáin, Navarra. Con fácil acceso y aparcamiento cercano.",
  },
  {
    q: "¿Cuál es el precio medio?",
    a: "El precio medio por persona se sitúa entre 20 € y 30 €, ofreciendo una excelente relación calidad-precio.",
  },
  {
    q: "¿Se puede comer en el local?",
    a: "Sí, el restaurante ofrece servicio completo para comer en sala con un ambiente cómodo y acogedor.",
  },
  {
    q: "¿Es adecuado para familias con niños?",
    a: "Absolutamente. Somos un restaurante familiar con ambiente cómodo para todas las edades. Las familias son siempre bienvenidas.",
  },
  {
    q: "¿Necesito reservar?",
    a: "Se recomienda reservar con antelación en horas punta para asegurar tu mesa. Puedes hacerlo directamente desde esta web o llamando al 948 59 55 67.",
  },
  {
    q: "¿Cuál es el horario de apertura?",
    a: "Estamos abiertos todos los días con servicio continuo hasta las 22:00. Consulta disponibilidad para eventos especiales.",
  },
];

const FAQSection = () => {
  const titleRef = useScrollAnimation();
  const faqRef = useScrollAnimation();

  return (
    <section id="faq" className="py-24 md:py-36 bg-[#0d0d0d]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-5 gap-16 md:gap-24">
          {/* Left label */}
          <div ref={titleRef} className="fade-in-left md:col-span-2 flex flex-col justify-start md:pt-4">
            <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Preguntas frecuentes</span>
            <div className="h-px w-12 bg-gold mt-3 mb-8" />
            <h2 className="font-heading text-4xl md:text-5xl text-[#ededed] leading-tight">
              Todo lo que<br />
              <span className="italic text-gold-dark">necesitas saber</span>
            </h2>
            <p className="font-body text-[#a3a3a3] text-base mt-6 leading-relaxed">
              Si tienes alguna otra duda, no dudes en llamarnos al{" "}
              <a href="tel:948595567" className="text-gold hover:underline">948 59 55 67</a>
            </p>
          </div>

          {/* Right accordion */}
          <div ref={faqRef} className="fade-in-right md:col-span-3">
            <Accordion type="single" collapsible className="space-y-0">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-0 border-b border-[#262626]"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-heading text-[#ededed] hover:text-gold hover:no-underline text-left py-6 text-base transition-colors duration-300">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[#a3a3a3] text-sm leading-relaxed pb-6">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
